const TedShareWhiteIcon = () => (
  <div>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1969_47113)">
        <path
          d="M7.19273 8.69274C6.71388 7.7369 5.72528 7.08073 4.58341 7.08073C2.97258 7.08073 1.66675 8.38657 1.66675 9.9974C1.66675 11.6082 2.97258 12.9141 4.58341 12.9141C5.72528 12.9141 6.71388 12.2579 7.19273 11.3021M7.19273 8.69274C7.3894 9.08531 7.50008 9.52843 7.50008 9.9974C7.50008 10.4664 7.3894 10.9095 7.19273 11.3021M7.19273 8.69274L12.8074 5.88539M7.19273 11.3021L12.8074 14.1094M12.8074 5.88539C13.2863 6.84123 14.2749 7.4974 15.4167 7.4974C17.0276 7.4974 18.3334 6.19156 18.3334 4.58073C18.3334 2.9699 17.0276 1.66406 15.4167 1.66406C13.8059 1.66406 12.5001 2.9699 12.5001 4.58073C12.5001 5.0497 12.6108 5.49282 12.8074 5.88539ZM12.8074 14.1094C12.6108 14.502 12.5001 14.9451 12.5001 15.4141C12.5001 17.0249 13.8059 18.3307 15.4167 18.3307C17.0276 18.3307 18.3334 17.0249 18.3334 15.4141C18.3334 13.8032 17.0276 12.4974 15.4167 12.4974C14.2749 12.4974 13.2863 13.1536 12.8074 14.1094Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1969_47113">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </div>
);
export default TedShareWhiteIcon;
